const Modal = ({modal, modalOpen,deleteItem,id}) => {
    return modal && (
        <div tabIndex={0} onBlur={() => modalOpen(false)}
                className="w-72 bg-gray-200 h-44 rounded-lg shadow dark:bg-gray-700 overflow-y-auto overflow-x-hidden top-1/2 left-1/2 inset-0 fixed -translate-x-1/2 -translate-y-1/2  z-50">
                <div className="flex">
                    <button onClick={() => modalOpen(false)} type="button"
                            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
                    >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd"
                                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                  clipRule="evenodd"/>
                        </svg>
                    </button>
                </div>
                <div className="p-6 pt-0 text-center">
                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Tem certeza que deseja
                        remover?</h3>
                    <button onClick={()=>{deleteItem(id)}} data-modal-toggle="popup-modal" type="button"
                            className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                        Sim
                    </button>
                    <button onClick={() => modalOpen(false)} data-modal-toggle="popup-modal" type="button"
                            className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:ring-gray-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600">
                        Cancelar
                    </button>
                </div>
        </div>
    )
}
export default Modal;